import { FC } from 'react';
import { useIntl } from 'react-intl';

import { TradedStatus } from '../status/traded/Traded';
import type { TradedSidePanelProps } from './Traded.connect';
import { connectTradedSidePanel } from './Traded.connect';

export const TradedSidePanel: FC<TradedSidePanelProps> = ({
  price,
  priceType,
  priceCurrency,
  onClick,
  tradeWay: tradeSide,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="d-flex flex-column h-100 overflow-y-auto">
      <TradedStatus price={price} priceType={priceType} priceCurrency={priceCurrency} tradeWay={tradeSide} />
      <div className="flex-grow-1" />
      <div className="d-flex flex-shrink-0 flex-column justify-content-end">
        <button type="button" onClick={onClick} className="btn btn-xl btn-primary m-1" data-e2e="btn-ok">
          {formatMessage({ id: 'secondaryMarket.sidePanel.cta.ok' })}
        </button>
      </div>
    </div>
  );
};
TradedSidePanel.displayName = 'TradeSidePanel';

export const ConnectedTradedSidePanel = connectTradedSidePanel(TradedSidePanel);

ConnectedTradedSidePanel.displayName = 'ConnectedTradedSidePanel';
